export function normalizePacName(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function isPacLikeName(value) {
  const normalized = normalizePacName(value);

  if (!normalized) return false;

  return (
    /\bpac\b/.test(normalized) ||
    /\bpolitical action committee\b/.test(normalized) ||
    /\bpolitical committee\b/.test(normalized) ||
    /\bopc\b/.test(normalized) ||
    /\bfirewall fund\b/.test(normalized) ||
    /\bfund\b/.test(normalized)
  );
}

export function isPacDonorProfile(donor) {
  if (!donor) return false;

  if (donor.entitySubType === "pac") return true;

  const names = [
    donor.displayName,
    ...(donor.knownNames || []).map((entry) => entry?.displayName),
  ].filter(Boolean);

  if (names.some(isPacLikeName)) {
    return true;
  }

  return (donor.donations || []).some((donation) => {
    const receiptType = String(donation?.receiptType || "").toLowerCase();
    return receiptType.includes("other committees");
  });
}

